<template>
    <div
        class="modal"
        v-if="active"
        :class="{ show: active === true }"
        @click="clickOutside($event)"
    >
        <div
            class="modal-backdrop show"
            :style="{ zIndex: 'unset' }"
            v-if="active === true"
        ></div>

        <section :style="{ zIndex: 1 }">
            <div class="modal-dialog popup" @click="clickInside($event)">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">
                            <template v-if="exists === false">
                                {{ trans("Create contact") }}
                            </template>
                            <template v-else>
                                {{ trans("Update contact") }}
                            </template>
                        </div>

                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="close()"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <form
                            class="rc-form"
                            id="contact-main-form"
                            @keydown="form.errors.clear($event.target.name)"
                        >
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label
                                        class="form-control-label"
                                        for="first_name"
                                        >{{ trans("First name") }}</label
                                    >

                                    <input
                                        name="first_name"
                                        id="first_name"
                                        v-focus
                                        class="form-control"
                                        :class="{
                                            'is-invalid': form.errors.has(
                                                'first_name'
                                            ),
                                        }"
                                        v-model="form.first_name"
                                        required
                                        type="text"
                                    />

                                    <div
                                        class="invalid-feedback"
                                        v-if="form.errors.has('first_name')"
                                    >
                                        {{ form.errors.get("first_name") }}
                                    </div>
                                </div>

                                <div class="col-12 form-group">
                                    <label
                                        class="form-control-label"
                                        for="last_name"
                                        >{{ trans("Last name") }}
                                        <span class="required">*</span></label
                                    >

                                    <input
                                        name="last_name"
                                        id="last_name"
                                        class="form-control"
                                        :class="{
                                            'is-invalid': form.errors.has(
                                                'last_name'
                                            ),
                                        }"
                                        v-model="form.last_name"
                                        :disabled="isRequesting"
                                        required
                                        type="text"
                                    />

                                    <div
                                        class="invalid-feedback"
                                        v-if="form.errors.has('last_name')"
                                    >
                                        {{ form.errors.get("last_name") }}
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label
                                        class="form-control-label"
                                        for="phone"
                                        >{{ trans("Phone") }}</label
                                    >

                                    <input
                                        name="phone"
                                        id="phone"
                                        class="form-control"
                                        :class="{
                                            'is-invalid': form.errors.has(
                                                'phone'
                                            ),
                                        }"
                                        v-model="form.phone"
                                        :disabled="isRequesting"
                                        required
                                        type="text"
                                    />

                                    <div
                                        class="invalid-feedback"
                                        v-if="form.errors.has('phone')"
                                    >
                                        {{ form.errors.get("phone") }}
                                    </div>
                                </div>

                                <div class="col-12 form-group">
                                    <label
                                        class="form-control-label"
                                        for="email"
                                        >{{ trans("E-mail") }}</label
                                    >

                                    <input
                                        name="email"
                                        id="email"
                                        class="form-control"
                                        :class="{
                                            'is-invalid': form.errors.has(
                                                'email'
                                            ),
                                        }"
                                        v-model="form.email"
                                        :disabled="isRequesting"
                                        required
                                        type="email"
                                    />

                                    <div
                                        class="invalid-feedback"
                                        v-if="form.errors.has('email')"
                                    >
                                        {{ form.errors.get("email") }}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!--/ modal-body -->

                    <div class="modal-footer">
                        <button @click="close()" class="btn btn-secondary">
                            {{ trans("cancel") }}
                        </button>

                        <button
                            v-if="exists === false"
                            :disabled="isRequesting"
                            type="button"
                            class="btn btn-primary"
                            @click="create()"
                        >
                            {{ trans("save") }}
                        </button>

                        <button
                            v-if="exists === true"
                            :disabled="isRequesting"
                            type="button"
                            class="btn btn-primary"
                            @click="update()"
                        >
                            {{ trans("save") }}
                        </button>
                    </div>
                </div>

                <div class="modal-shadow" v-if="isRequesting === true"></div>
            </div>
        </section>
    </div>
</template>

<script>
import { Form } from "../../classes/Form";

export default {
    data() {
        return {
            form: new Form({
                first_name: "",
                last_name: "",
                phone: "",
                email: "",
            }),
            exists: false,
            isRequesting: true,
        };
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        contact_id: {
            type: Number,
            default: null,
        },
    },
    methods: {
        clickOutside(event) {
            const self = this;

            if (!jQuery(event.target).closest(".popup").length) {
                self.close();
            }
        },
        clickInside(event) {
            // Disabled due to make checkboxes inactive
            // event.preventDefault();
        },
        close() {
            const self = this;

            // Cleanup
            self.form.clear();

            self.isRequesting = true;

            self.$emit("close", true);
        },
        init() {
            const self = this;

            self.isRequesting = true;

            if (self.contact_id === null) {
                self.exists = false;
                self.isRequesting = false;

                return;
            }

            // Cleanup all notifications
            self.$snotify.clear();

            self.$snotify.async(
                trans("Load fresh information"),
                "",
                () =>
                    new Promise((resolve, reject) => {
                        axios
                            .post(
                                route("contact.show-post", {
                                    contact: self.contact_id,
                                })
                            )
                            .then((response) => {
                                resolve({
                                    title: trans("Success!"),
                                    config: {
                                        timeout: 300,
                                        pauseOnHover: true,
                                        closeOnClick: true,
                                    },
                                });

                                let data = response.data;

                                self.contact = data.contact;

                                self.form.setDefaultValues(self.contact);

                                self.exists = true;

                                self.isRequesting = false;
                            })
                            .catch(() => {
                                reject({
                                    title: trans("Error!"),
                                    body: trans(
                                        "Something went wrong, please re-check and try again"
                                    ),
                                    config: {
                                        timeout: 1000,
                                        closeOnClick: true,
                                    },
                                });
                            });
                    })
            );
        },
        create() {
            const self = this;

            self.isRequesting = true;

            self.$snotify.async(
                trans("Creating contact"),
                "",
                () =>
                    new Promise((resolve, reject) => {
                        self.form
                            .post(route("contact.store"))
                            .then((response) => {
                                window.location = response.redirect;

                                resolve({
                                    title: trans("Success!"),
                                });
                            })
                            .catch(() => {
                                reject({
                                    title: trans("Error!"),
                                    body: trans(
                                        "Something went wrong, please re-check and try again"
                                    ),
                                    config: {
                                        closeOnClick: true,
                                    },
                                });

                                self.isRequesting = false;
                            });
                    }),
                {
                    timeout: 3000,
                    showProgressBar: true,
                }
            );
        },
        update() {
            const self = this;

            self.isRequesting = true;

            self.$snotify.async(
                trans("Updating contact"),
                "",
                () =>
                    new Promise((resolve, reject) => {
                        self.form
                            .put(
                                route("contact.update", {
                                    contact: self.contact_id,
                                })
                            )
                            .then((response) => {
                                self.close();

                                resolve();
                            })
                            .catch(() => {
                                reject({
                                    title: trans("Error!"),
                                    body: trans(
                                        "Something went wrong, please re-check and try again"
                                    ),
                                    config: {
                                        closeOnClick: true,
                                    },
                                });

                                self.isRequesting = false;
                            });
                    }),
                {
                    timeout: 3000,
                    showProgressBar: true,
                }
            );
        },
    },
    mounted() {
        const self = this;

        jQuery(document).on("keypress", "#contact-main-form", function(e) {
            if (e.keyCode == 13 && e.target.type != "textarea") {
                e.preventDefault();
                self.exists ? self.update() : self.create();
            }
        });
    },
    watch: {
        active(value) {
            const self = this;

            if (value) {
                document.body.classList.add("modal-open");

                self.init();
            } else {
                document.body.classList.remove("modal-open");
            }
        },
        contact_id(value) {
            const self = this;
        },
    },
    computed: {},
};
</script>
